import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=2662a6e7&scoped=true&"
import script from "./Breakdown.vue?vue&type=script&lang=js&"
export * from "./Breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2662a6e7",
  null
  
)

export default component.exports